<script>export let name;
export let label;
export let icon;
export let hasHandler = false;
export let active = false;
</script>

<div class="launcher{hasHandler ? ' '+name : ' nohandler'}" data-name="{name}">
  <a class="{name} tlmd-launcher {active ? 'active' : ''}" href="#top"
    ><span class={icon}></span></a
  ><span class="label">{label}</span>
</div>

<style>
  div.launcher {
    --base-color-primary-default: #6bae85;


    --color-tlmd-main-fg: #c3c7cb;

    --btn-color-tlmd-launcher-0: #1a1b1f;
    --btn-color-tlmd-launcher-1: #0e0e11;
    --btn-color-tlmd-launcher-2: #020203;
    --btn-color-tlmd-launcher-3: #000;
    --btn-color-tlmd-launcher-4: #000;
    --btn-color-tlmd-launcher-fg-0: #69b365;
    --btn-color-tlmd-launcher-fg-1: #8ac487;

    --legacy-label-fg-color: var(--color-tlmd-main-fg);

    --legacy-fg-color: var(--btn-color-tlmd-launcher-fg-0);
    --legacy-bg-color: var(--btn-color-tlmd-launcher-0);
    --legacy-bd-color: var(--btn-color-tlmd-launcher-1);

    --legacy-fg-hover-color: var(--btn-color-tlmd-launcher-fg-1);
    --legacy-bg-hover-color: var(--btn-color-tlmd-launcher-2);
    --legacy-bd-hover-color: var(--btn-color-tlmd-launcher-4);

    --legacy-fg-active-color: var(--btn-color-tlmd-launcher-2);
    --legacy-bg-active-color: var(--btn-color-tlmd-launcher-fg-0);
    --legacy-bd-active-color: var(--btn-color-tlmd-launcher-4);

    --legacy-activated-fg-color: var(--btn-color-tlmd-launcher-2);
    --legacy-activated-bg-color: var(--btn-color-tlmd-launcher-fg-0);
    --legacy-activated-bd-color: var(--btn-color-tlmd-launcher-4);

    --legacy-activated-fg-hover-color: var(--btn-color-tlmd-launcher-3);
    --legacy-activated-bg-hover-color: var(--btn-color-tlmd-launcher-fg-1);
    --legacy-activated-bd-hover-color: var(--btn-color-tlmd-launcher-4);

    --legacy-activated-fg-active-color: var(--btn-color-tlmd-launcher-fg-0);
    --legacy-activated-bg-active-color: var(--btn-color-tlmd-launcher-2);
    --legacy-activated-bd-active-color: var(--btn-color-tlmd-launcher-4);


    --label-fg-color: var(--legacy-label-fg-color);

    --fg-color: var(--legacy-fg-color);
    --bg-color: var(--legacy-bg-color);
    --bd-color: var(--legacy-bd-color);
    --fg-hover-color: var(--legacy-fg-hover-color);
    --bg-hover-color: var(--legacy-bg-hover-color);
    --bd-hover-color: var(--legacy-bd-hover-color);
    --fg-active-color: var(--legacy-fg-active-color);
    --bg-active-color: var(--legacy-bg-active-color);
    --bd-active-color: var(--legacy-bd-active-color);

    --activated-fg-color: var(--legacy-activated-fg-color);
    --activated-bg-color: var(--legacy-activated-bg-color);
    --activated-bd-color: var(--legacy-activated-bd-color);
    --activated-fg-hover-color: var(--legacy-activated-fg-hover-color);
    --activated-bg-hover-color: var(--legacy-activated-bg-hover-color);
    --activated-bd-hover-color: var(--legacy-activated-bd-hover-color);
    --activated-fg-active-color: var(--legacy-activated-fg-active-color);
    --activated-bg-active-color: var(--legacy-activated-bg-active-color);
    --activated-bd-active-color: var(--legacy-activated-bd-active-color);

    --icon-size: 2rem;
    --launcher-size: 1.5em;
    --border-size: 0.0625em;
  }

  div.launcher {
    display: inline-block;
    text-align: center;
    vertical-align: top;
    padding-top: 0.375rem;
    width: 6.25rem; /*100px*/
    max-width: 6.25rem;
    min-width: 6.25rem;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
  .label {
    margin-top: 0.25rem;
    color: var(--label-fg-color);
    display:block;
    /* base/typography/desktop/label/small */
font-family: Roboto;
font-size: 0.6875rem;
font-style: normal;
font-weight: 700;
line-height: 0.75rem;
letter-spacing: 1px; 
  }
  a {
    display: inline-block;
    font-weight: normal;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    text-decoration: none;
    outline-width: 0 !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
  }
  a {
    border-radius: 8px;
    border: var(--border-size) solid transparent;
  }
  a {
    color: var(--fg-color);
    background-color: var(--bg-color);
    border-color: var(--bd-color);
  }
  a:focus,
  a:hover {
    color: var(--fg-hover-color);
    background-color: var(--bg-hover-color);
    border-color: var(--bd-hover-color);
  }
  a:active {
    color: var(--fg-active-color);
    background-color: var(--bg-active-color);
    border-color: var(--bd-active-color);
  }
  a.active {
    background-color: var(--activated-bg-color);
    color: var(--activated-fg-color);
    border-color: var(--activated-bd-color);
  }
  a.active:focus,
  a.active:hover {
    color: var(--activated-fg-hover-color);
    background-color: var(--activated-bg-hover-color);
    border-color: var(--activated-bd-hover-color);
  }
  a.active:active {
    color: var(--activated-fg-active-color);
    background-color: var(--activated-bg-active-color);
    border-color: var(--activated-bd-active-color);
  }


  a > span[class^="glyph-"],
  a > span[class*=" glyph-"],
  a > span[class^="icon-"],
  a > span[class*=" icon-"] {
    font-size: var(--icon-size);
    line-height: var(--launcher-size);
    width: var(--launcher-size);
    display: inline-block;
    vertical-align: middle;
  }
</style>
